class SizingCalculator extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelectorAll(".toggle-btn"),
            t = this.querySelector("#toggleSwitchBtns"),
            i = this.querySelector(".toggle-btn.toggle-inch"),
            s = this.querySelector(".toggle-btn.toggle-cm"),
            r = this.querySelector(".calculator-input-fields-wrapper.inch-variant"),
            n = this.querySelector(".calculator-input-fields-wrapper.cm-variant");

        this.ribcageInputINCH = this.querySelector(".inch-variant .ribcage-input");
        this.bustInputINCH = this.querySelector(".inch-variant .bust-input");
        this.ribcageInputCM = this.querySelector(".cm-variant .ribcage-input");
        this.bustInputCM = this.querySelector(".cm-variant .bust-input");
        this.getSizeBtn = this.querySelector(".calculator-get-results");
        this.results = this.querySelector(".calculator-results");
        this.resultWrapper = this.querySelector(".pepper-size-results-wrapper");
        this.resultTitle = this.querySelector(".result-title");
        this.errorTitle = this.querySelector(".error-wrapper");
        this.shopLinkWrapper = this.querySelector(".pepper-results-shop-btn");

        this.ribcageSizesINCH = {
            28: [25, 26.9],
            30: [27, 28.9],
            32: [29, 30.9],
            34: [31, 32.9],
            36: [33, 34.9],
            38: [35, 36.9],
            40: [37, 38.9]
        };

        this.ribcageSizesCM = {
            60: [63, 67],
            65: [68, 72],
            70: [73, 77],
            75: [78, 82],
            80: [83, 87],
            85: [89, 91],
            90: [92, 95]
        };

        this.ribcageSizesIT = { 
            "-1": [63, 67],
            0: [68, 72],
            1: [73, 77],
            2: [78, 82],
            3: [83, 87],
            4: [89, 91],
            5: [92, 95]
        };

        this.ribcageSizesFR = {
            75: [63, 67],
            80: [68, 72],
            85: [73, 77],
            90: [78, 82],
            95: [83, 87],
            100: [89, 91],
            105: [92, 95]
        };

        this.ribcageSizesAU = {
            6: [63, 67],
            8: [68, 72],
            10: [73, 77],
            12: [78, 82],
            14: [83, 87],
            16: [89, 91],
            18: [92, 95]
        };

        this.cupSizesINCH = {
            29: { 32: "AA", 30: "A", 28: "B" },
            30: { 32: "AA", 30: "A", 28: "B" },
            31: { 34: "AA", 32: "A", 30: "B", 28: "C" },
            32: { 34: "AA", 32: "A", 30: "B", 28: "C" },
            33: { 36: "AA", 34: "A", 32: "B", 30: "C" },
            34: { 36: "AA", 34: "A", 32: "B", 30: "C" },
            35: { 38: "AA", 36: "A", 34: "B", 32: "C" },
            36: { 38: "AA", 36: "A", 34: "B", 32: "C" },
            37: { 40: "AA", 38: "A", 36: "B", 34: "C" },
            38: { 40: "AA", 38: "A", 36: "B", 34: "C" },
            39: { 40: "A", 38: "B", 36: "C" },
            40: { 40: "A", 38: "B", 36: "C" },
            41: { 40: "B", 38: "C" },
            42: { 40: "B", 38: "C" },
            43: { 40: "C" },
            44: { 40: "C" }
        };

        this.cupSizesCM = {
            73: { 60: "B", 65: "A", 70: "AA" },
            74: { 60: "B", 65: "A", 70: "AA" },
            75: { 60: "B", 65: "A", 70: "AA" },
            76: { 60: "B", 65: "A", 70: "AA" },
            77: { 60: "B", 65: "A", 70: "AA" },
            78: { 60: "C", 65: "B", 75: "A", 80: "AA" },
            79: { 60: "C", 65: "B", 75: "A", 80: "AA" },
            80: { 60: "C", 65: "B", 75: "A", 80: "AA" },
            81: { 60: "C", 65: "B", 75: "A", 80: "AA" },
            82: { 60: "C", 65: "B", 75: "A", 80: "AA" },
            83: { 65: "C", 70: "B", 80: "A", 85: "AA" },
            84: { 65: "C", 70: "B", 80: "A", 85: "AA" },
            85: { 65: "C", 70: "B", 80: "A", 85: "AA" },
            86: { 65: "C", 70: "B", 80: "A", 85: "AA" },
            87: { 65: "C", 70: "B", 80: "A", 85: "AA" },
            88: { 70: "C", 75: "B", 80: "A", 85: "AA" },
            89: { 70: "C", 75: "B", 80: "A", 85: "AA" },
            90: { 70: "C", 75: "B", 80: "A", 85: "AA" },
            91: { 70: "C", 75: "B", 80: "A", 85: "AA" },
            92: { 70: "C", 75: "B", 80: "A", 85: "AA" },
            93: { 70: "C", 75: "B", 80: "A", 85: "AA" },
            94: { 75: "C", 80: "B", 85: "A", 90: "AA" },
            95: { 75: "C", 80: "B", 85: "A", 90: "AA" },
            96: { 75: "C", 80: "B", 85: "A", 90: "AA" },
            97: { 75: "C", 80: "B", 85: "A", 90: "AA" },
            98: { 75: "C", 80: "B", 85: "A", 90: "AA" },
            99: { 80: "C", 85: "B", 90: "A" },
            100: { 80: "C", 85: "B", 90: "A" },
            101: { 80: "C", 85: "B", 90: "A" },
            102: { 80: "C", 85: "B", 90: "A" },
            103: { 80: "C", 85: "B", 90: "A" },
            104: { 85: "C", 90: "B" },
            105: { 85: "C", 90: "B" },
            106: { 85: "C", 90: "B" },
            107: { 85: "C", 90: "B" },
            108: { 90: "C" },
            109: { 90: "C" },
            110: { 90: "C" },
            111: { 90: "C" }
        };

        this.cupSizesIT = { 
            73: { "-1": "B", 0: "A", 1: "AA" },
            74: { "-1": "B", 0: "A", 1: "AA" },
            75: { "-1": "B", 0: "A", 1: "AA" },
            76: { "-1": "B", 0: "A", 1: "AA" },
            77: { "-1": "B", 0: "A", 1: "AA" },
            78: { "-1": "C", 0: "B", 1: "A", 2: "AA" },
            79: { "-1": "C", 0: "B", 1: "A", 2: "AA" },
            80: { "-1": "C", 0: "B", 1: "A", 2: "AA" },
            81: { "-1": "C", 0: "B", 1: "A", 2: "AA" },
            82: { "-1": "C", 0: "B", 1: "A", 2: "AA" },
            83: { 0: "C", 1: "B", 2: "A", 3: "AA" },
            84: { 0: "C", 1: "B", 2: "A", 3: "AA" },
            85: { 0: "C", 1: "B", 2: "A", 3: "AA" },
            86: { 0: "C", 1: "B", 2: "A", 3: "AA" },
            87: { 0: "C", 1: "B", 2: "A", 3: "AA" },
            88: { 1: "C", 2: "B", 3: "A", 4: "AA" },
            89: { 1: "C", 2: "B", 3: "A", 4: "AA" },
            90: { 1: "C", 2: "B", 3: "A", 4: "AA" },
            91: { 1: "C", 2: "B", 3: "A", 4: "AA" },
            92: { 1: "C", 2: "B", 3: "A", 4: "AA" },
            93: { 1: "C", 2: "B", 3: "A", 4: "AA" },
            94: { 2: "C", 3: "B", 4: "A", 5: "AA" },
            95: { 2: "C", 3: "B", 4: "A", 5: "AA" },
            96: { 2: "C", 3: "B", 4: "A", 5: "AA" },
            97: { 2: "C", 3: "B", 4: "A", 5: "AA" },
            98: { 2: "C", 3: "B", 4: "A", 5: "AA" },
            99: { 3: "C", 4: "B", 5: "A" },
            100: { 3: "C", 4: "B", 5: "A" },
            101: { 3: "C", 4: "B", 5: "A" },
            102: { 3: "C", 4: "B", 5: "A" },
            103: { 3: "C", 4: "B", 5: "A" },
            104: { 4: "C", 5: "B" },
            105: { 4: "C", 5: "B" },
            106: { 4: "C", 5: "B" },
            107: { 4: "C", 5: "B" },
            108: { 5: "C" },
            109: { 5: "C" },
            110: { 5: "C" },
            111: { 5: "C" }
         };
        this.cupSizesFR = {
            73: { 75: "B", 80: "A", 85: "AA" },
            74: { 75: "B", 80: "A", 85: "AA" },
            75: { 75: "B", 80: "A", 85: "AA" },
            76: { 75: "B", 80: "A", 85: "AA" },
            77: { 75: "B", 80: "A", 85: "AA" },
            78: { 75: "C", 80: "B", 85: "A", 90: "AA" },
            79: { 75: "C", 80: "B", 85: "A", 90: "AA" },
            80: { 75: "C", 80: "B", 85: "A", 90: "AA" },
            81: { 75: "C", 80: "B", 85: "A", 90: "AA" },
            82: { 75: "C", 80: "B", 85: "A", 90: "AA" },
            83: { 80: "C", 85: "B", 90: "A", 95: "AA" },
            84: { 80: "C", 85: "B", 90: "A", 95: "AA" },
            85: { 80: "C", 85: "B", 90: "A", 95: "AA" },
            86: { 80: "C", 85: "B", 90: "A", 95: "AA" },
            87: { 80: "C", 85: "B", 90: "A", 95: "AA" },
            88: { 85: "C", 90: "B", 95: "A", 100: "AA" },
            89: { 85: "C", 90: "B", 95: "A", 100: "AA" },
            90: { 85: "C", 90: "B", 95: "A", 100: "AA" },
            91: { 85: "C", 90: "B", 95: "A", 100: "AA" },
            92: { 85: "C", 90: "B", 95: "A", 100: "AA" },
            93: { 85: "C", 90: "B", 95: "A", 100: "AA" },
            94: { 90: "C", 95: "B", 100: "A", 105: "AA" },
            95: { 90: "C", 95: "B", 100: "A", 105: "AA" },
            96: { 90: "C", 95: "B", 100: "A", 105: "AA" },
            97: { 90: "C", 95: "B", 100: "A", 105: "AA" },
            98: { 90: "C", 95: "B", 100: "A", 105: "AA" },
            99: { 95: "C", 100: "B", 105: "A" },
            100: { 95: "C", 100: "B", 105: "A" },
            101: { 95: "C", 100: "B", 105: "A" },
            102: { 95: "C", 100: "B", 105: "A" },
            103: { 95: "C", 100: "B", 105: "A" },
            104: { 100: "C", 105: "B" },
            105: { 100: "C", 105: "B" },
            106: { 100: "C", 105: "B" },
            107: { 100: "C", 105: "B" },
            108: { 105: "C" },
            109: { 105: "C" },
            110: { 105: "C" },
            111: { 105: "C" }
        };
        this.cupSizesAU = {
            73: { 6: "B", 8: "A", 10: "AA" },
            74: { 6: "B", 8: "A", 10: "AA" },
            75: { 6: "B", 8: "A", 10: "AA" },
            76: { 6: "B", 8: "A", 10: "AA" },
            77: { 6: "B", 8: "A", 10: "AA" },
            78: { 6: "C", 8: "B", 10: "A", 12: "AA" },
            79: { 6: "C", 8: "B", 10: "A", 12: "AA" },
            80: { 6: "C", 8: "B", 10: "A", 12: "AA" },
            81: { 6: "C", 8: "B", 10: "A", 12: "AA" },
            82: { 6: "C", 8: "B", 10: "A", 12: "AA" },
            83: { 8: "C", 10: "B", 12: "A", 14: "AA" },
            84: { 8: "C", 10: "B", 12: "A", 14: "AA" },
            85: { 8: "C", 10: "B", 12: "A", 14: "AA" },
            86: { 8: "C", 10: "B", 12: "A", 14: "AA" },
            87: { 8: "C", 10: "B", 12: "A", 14: "AA" },
            88: { 10: "C", 12: "B", 14: "A", 16: "AA" },
            89: { 10: "C", 12: "B", 14: "A", 16: "AA" },
            90: { 10: "C", 12: "B", 14: "A", 16: "AA" },
            91: { 10: "C", 12: "B", 14: "A", 16: "AA" },
            92: { 10: "C", 12: "B", 14: "A", 16: "AA" },
            93: { 10: "C", 12: "B", 14: "A", 16: "AA" },
            94: { 12: "C", 14: "B", 16: "A", 18: "AA" },
            95: { 12: "C", 14: "B", 16: "A", 18: "AA" },
            96: { 12: "C", 14: "B", 16: "A", 18: "AA" },
            97: { 12: "C", 14: "B", 16: "A", 18: "AA" },
            98: { 12: "C", 14: "B", 16: "A", 18: "AA" },
            99: { 14: "C", 16: "B", 18: "A" },
            100: { 14: "C", 16: "B", 18: "A" },
            101: { 14: "C", 16: "B", 18: "A" },
            102: { 14: "C", 16: "B", 18: "A" },
            103: { 14: "C", 16: "B", 18: "A" },
            104: { 16: "C", 18: "B" },
            105: { 16: "C", 18: "B" },
            106: { 16: "C", 18: "B" },
            107: { 16: "C", 18: "B" },
            108: { 18: "C" },
            109: { 18: "C" },
            110: { 18: "C" },
            111: { 18: "C" }
        };

        const country = (window.Shopify && Shopify.country) ? Shopify.country.toUpperCase() : 'US';

        if (country === 'US') {
            this.dataset.variant = "inch";
            this.ribcageSizes = this.ribcageSizesINCH;
            this.cupSizes = this.cupSizesINCH;
        } else if (country === 'IT') {
            this.dataset.variant = "cm";
            this.ribcageSizes = this.ribcageSizesIT;
            this.cupSizes = this.cupSizesIT;
        } else if (country === 'FR') {
            this.dataset.variant = "cm";
            this.ribcageSizes = this.ribcageSizesFR;
            this.cupSizes = this.cupSizesFR;
            console.log("This is FRANCE")
        } else if (country === 'AU') {
            this.dataset.variant = "cm";
            this.ribcageSizes = this.ribcageSizesAU;
            this.cupSizes = this.cupSizesAU;
        } else {
            this.dataset.variant = "cm";
            this.ribcageSizes = this.ribcageSizesCM;
            this.cupSizes = this.cupSizesCM;
        }

        if (this.dataset.variant === "inch") {
            i.classList.add("active");
            r.classList.add("active");
            s.classList.remove("active");
            n.classList.remove("active");
            t.checked = false;
        } else {
            s.classList.add("active");
            n.classList.add("active");
            i.classList.remove("active");
            r.classList.remove("active");
            t.checked = true;
        }

        [...e].forEach(e2 => {
            e2.addEventListener("click", () => {
                t.checked = !t.checked;
                [i, s, r, n].forEach(e3 => e3.classList.toggle("active"));
                if (this.dataset.variant === "inch") {
                    this.dataset.variant = "cm";
                    this.ribcageSizes = this.ribcageSizesCM;
                    this.cupSizes = this.cupSizesCM;
                } else {
                    this.dataset.variant = "inch";
                    this.ribcageSizes = this.ribcageSizesINCH;
                    this.cupSizes = this.cupSizesINCH;
                }
            });
        });
    }

    roundSpecWay(e) {
        e = e.replace(",", ".");
        let t = (e = parseFloat(e)) % 1, i = e - t;
        return t > .5 ? i + 1 : i;
    }

    getRibcageBandSize(e) {
        e = this.roundSpecWay(e);
        let t = !1;
        for (const i in this.ribcageSizes) {
            if (this.ribcageSizes.hasOwnProperty(i)) {
                const s = this.ribcageSizes[i];
                if (e >= s[0] && e <= s[1]) {
                    t = i;
                    break;
                }
            }
        }
        return t;
    }

    getBustSize(e) {
        return this.roundSpecWay(e);
    }

    getCupSize(e, t) {
        if (this.cupSizes.hasOwnProperty(t)) return this.cupSizes[t][e] || !1;
    }

    showError() {
        this.errorTitle.classList.remove("stealth");
        this.results.classList.add("stealth");
        this.shopLinkWrapper.classList.add("stealth");
    }

    handleFormSubmit(e) {
        if (e.type === "click" || e.type === "keyup" && e.key === "Enter") {
            const e2 = this.dataset.variant;
            let t = e2 == "inch" ? this.ribcageInputINCH.value : this.ribcageInputCM.value,
                i = e2 == "inch" ? this.bustInputINCH.value : this.bustInputCM.value;
            t = this.getRibcageBandSize(t);
            i = this.getBustSize(i);
            let s = t,
                r = this.getCupSize(t, i);

            console.log("Band size:", t);
            console.log("Bust size:", i);
            console.log("Cup size result:", r);
            console.log("Current cup size table:", this.cupSizes);

            if (!(t && i && r)) return this.showError();
            {
                this.errorTitle.classList.add("stealth");
                this.results.classList.remove("stealth");
                this.results.classList.remove("mobile-hidden");
                this.shopLinkWrapper.classList.remove("stealth");
                this.results.classList.add("border-black");
                this.resultTitle.classList.add("color-black");
                const e3 = this.querySelector(".shop_my_size");
                let t2 = e3.dataset.href,
                    i2 = s + "" + r;
                i2.indexOf("XL") > -1 && (i2 = r);
                this.resultWrapper.textContent = i2;
                this.resultWrapper.classList.remove("stealth");
                t2 += "?70618611795=" + i2;
                e3.setAttribute("href", t2);
            }
        }
    }

    connectedCallback() {
        this.getSizeBtn.addEventListener("click", this.handleFormSubmit.bind(this));
    }
}

customElements.define("sizing-calculator", SizingCalculator);

class SizeChartExpander extends HTMLElement {
    constructor() {
        super(), this.size_chart_selector = this.querySelector(".size_chart_title_and_selector"), this.menu_opener = this.querySelector(".menu-opener-wrapper"), this.menu_opener.addEventListener("click", this.toggleExpand.bind(this)), this.content_wrapper = this.querySelector(".dropdown-content");
        const e = this.querySelector(".chart-buttons-wrapper");
        e && [...e?.querySelectorAll(".toggle-btn")].forEach(e2 => e2.addEventListener("click", () => {
            this.close(), this.open()
        }))
    }
    open() {
        const e = this.content_wrapper.offsetHeight > this.getHeight(this.content_wrapper) ? this.content_wrapper.offsetHeight : this.getHeight(this.content_wrapper);
        this.content_wrapper.style.setProperty("height", `${e}px`)
    }
    close() {
        this.content_wrapper.style.removeProperty("height")
    }
    getHeight(e) {
        const t = e.cloneNode(!0);
        document.body.appendChild(t);
        let i = 0;
        const {
            desktop: s
        } = BREAKPOINTS();
        return i = s ? +t.clientHeight : t.classList.contains("size-conversion-table-container") ? 400 : +t.clientHeight, document.body.removeChild(t), i
    }
    toggleExpand() {
        const e = this.getAttribute("aria-expanded") == "true";
        e ? this.close() : this.open(), this.setAttribute("aria-expanded", !e)
    }
}
customElements.define("size-chart-expander", SizeChartExpander);

class ProductCard extends HTMLElement {
    constructor() {
        super(), this.images = this.querySelectorAll(".js-img"), this.links = this.querySelectorAll(".js-link"), this.titles = this.querySelectorAll("[data-producttitle]"), this.swatches = this.querySelector("product-swatches"), this.filters = document.querySelector("collection-filters"), this.message = this.querySelector(".card__message "), this.swatches?.addEventListener("swatches-ready", e => {
            this.getStylePrice(e)
        })
    }
    initSwatchesCarousel() {
        const e = this.swatches.querySelector("swiper-container"),
            t = this.titles;
        if (!e) return;
        const i = {
            prevEl: this.swatches.querySelector(".btn-slide-prev--color-swatch-slider"),
            nextEl: this.swatches.querySelector(".btn-slide-next--color-swatch-slider")
        };
        Object.assign(e, {
            slidesPerView: "auto",
            spaceBetween: 0,
            observer: !0,
            observeParents: !0,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            watchSlidesProgress: !0,
            navigation: i,
            on: {
                init: function() {
                    i.prevEl.classList.toggle("invisible", i.prevEl.classList.contains("swiper-button-disabled")), i.nextEl.classList.toggle("invisible", i.nextEl.classList.contains("swiper-button-disabled"))
                },
                reachBeginning: function() {
                    i.prevEl.classList.add("invisible"), i.nextEl.classList.remove("invisible")
                },
                reachEnd: function() {
                    i.prevEl.classList.remove("invisible"), i.nextEl.classList.add("invisible")
                },
                slideChange: function() {
                    (window.dataLayer || []).push({
                        event: "card_swatches_swipe",
                        eventLabel: `${t[0]?.dataset?.producttitle}`
                    })
                }
            }
        }), e.initialize()
    }
    disableCardHover(e) {
        this.classList.toggle("no-hover", e.type === "pointerover")
    }
    getStylePrice(e) {
        const t = e.detail.products,
            i = new Set;
        if (t.forEach(e2 => {
                e2.variants.forEach(e3 => {
                    i.add(e3.price)
                })
            }), i.size <= 1) return;
        const s = Math.min(...i),
            r = this.querySelector("[data-price-format]").dataset.priceFormat.replace("[x]", s / 100),
            n = document.createElement("div");
        n.className = "sale-string abc-whyte-book text-14", n.textContent = `select colors ${r}`, this.querySelector(".rating-wrapper").append(n)
    }
    updatePrice(e) {
        this.querySelector(".sale-string")?.remove(), getProductPriceByHandle(e.handle, e2 => {
            const t = this.querySelector(".card_product_price_holder"),
                i = e2.querySelector(".price");
            t.innerHTML = i.innerHTML
        }, e2 => {
            console.error(e2)
        })
    }
    updateMessage(e) {
        const t = e.variants.some(e2 => e2.available),
            i = e?.metafields?.find(e2 => e2?.references?.find(e3 => e3.value === "Coming Soon"));
        this.message.textContent = i ? "Coming Soon" : t ? "Shop" : "Sold Out"
    }
    updateLinks(e) {
        this.links.forEach(t => {
            t?.setAttribute("href", `/products/${e.handle}`)
        })
    }
    updateTitle(e) {
        this.titles.forEach(t => {
            t?.setAttribute("data-producttitle", e.title)
        })
    }
    updateImages(e) {
        e.media.slice(0, this.images.length).forEach((e2, t) => {
            this.images?.[t]?.setAttribute("src", `${e2.src}&width=650`)
        })
    }
    updateDataLayer(e) {
        (window.dataLayer || []).push({
            event: "card_swatches_change",
            eventLabel: `${e.title}`
        })
    }
    updateCard(e) {
        this.updateImages(e), this.updateLinks(e), this.updatePrice(e), this.updateTitle(e), this.updateMessage(e), this.updateDataLayer(e)
    }
    eventHandlers(e = !1) {
        if (!this.swatches) return;
        const t = e ? "addEventListener" : "removeEventListener";
        ["pointerover", "pointerleave"].forEach(e2 => this.swatches[t](e2, this.disableCardHover.bind(this)))
    }
    connectedCallback() {
        this.eventHandlers(!0)
    }
    disconnectedCallback() {
        this.eventHandlers()
    }
}
customElements.define("product-card", ProductCard);

//# source MappingURL=/s/files/1/0849/2997/0500/t/24/assets/custom-size.js.map?v=1737553906